export default function getCartItemVariant(cartItem) {
    var _a, _b, _c, _d;
    const isVariant = cartItem.variant;
    const variantImage = (_b = (_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.variant) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b[0];
    const hasVariantImage = !!variantImage;
    const variantValues = (_d = (_c = cartItem === null || cartItem === void 0 ? void 0 : cartItem.variant) === null || _c === void 0 ? void 0 : _c.values) !== null && _d !== void 0 ? _d : [];
    return { isVariant, hasVariantImage, variantImage, variantValues };
}
//# sourceMappingURL=getCartItemVariant.js.map